import 'css-chunksrc/client/scenes/strategicAxisCreation/form/styles.scss';export default {
  "form": "_form_1t63d_1",
  "group": "_group_1t63d_5",
  "row": "_row_1t63d_9",
  "horizontalRow": "_horizontalRow_1t63d_20",
  "label": "_label_1t63d_26",
  "description": "_description_1t63d_32",
  "root": "_root_1t63d_36",
  "listRoot": "_listRoot_1t63d_40",
  "icon": "_icon_1t63d_48",
  "input": "_input_1t63d_57",
  "opened": "_opened_1t63d_76",
  "list": "_list_1t63d_40",
  "selected": "_selected_1t63d_97",
  "option": "_option_1t63d_101"
};